import { useRef, type ReactNode } from 'react';
import { useInView, useReducedMotion } from 'motion/react';
import { useHasMounted } from '../../../hooks/useHasMounted';
import styles from './Marker.module.css';

const IN_VIEW_MARGIN = '0px 0px -10% 0px';

/**
 * A yellow highlighter stroke painted over a few words. The server renders it fully drawn;
 * in the browser it sweeps in once the words scroll into view.
 */
export default function Marker({ children }: { children?: ReactNode }) {
    const ref = useRef<HTMLElement>(null);
    const hasMounted = useHasMounted();
    const prefersReducedMotion = useReducedMotion();
    const isInView = useInView(ref, { once: true, margin: IN_VIEW_MARGIN });
    const isDrawn = !hasMounted || prefersReducedMotion === true || isInView;

    return (
        <mark ref={ref} className={styles.marker} data-drawn={isDrawn}>
            {children}
        </mark>
    );
}
